export const ConsumerPhoneValidationResendCodeBannerStyle = {
  bannerWrapper: 'w-full flex justify-center pt-1',
  bannerContainer: 'mb-4 max-w-max',
}
